import React, { ReactNode, forwardRef } from 'react';
import { StyledHeadingProps, StyledHeading, StandardHeadlineSize } from './heading.styles';

interface HeadingProps extends StyledHeadingProps {
  text?: string;
  children?: ReactNode;
  className?: string;
}

const Heading = (props: HeadingProps, ref: React.ForwardedRef<HTMLHeadingElement>): JSX.Element => {
  const { standardSize } = props;

  const size = props.size || StandardHeadlineSize[standardSize]?.desktop;
  const sizeLg = props.sizeLg || StandardHeadlineSize[standardSize]?.lg;
  const sizeSm = props.sizeSm || StandardHeadlineSize[standardSize]?.sm;

  return (
    <StyledHeading
      ref={ref}
      // Props spread should be before 'sizeX' as the props' key is named the same and spread could override with prop.sizeSm = null
      {...props}
      className={props.className}
      size={size}
      sizeLg={sizeLg}
      sizeSm={sizeSm}
    >
      {props.text || props.children}
    </StyledHeading>
  );
};

export default forwardRef<HTMLHeadingElement, HeadingProps>(Heading);
